import { type OnBehalfOfInput, gqlClient, graphql } from '@tyro/api';

const setupIntent = graphql(/* GraphQL */ `
  mutation fees_createSetupIntent($input: OnBehalfOfInput) {
    fees_createSetupIntent(input: $input) {
      clientSecret
    }
  }
`);

export function getSetupIntentSecret(input?: OnBehalfOfInput) {
  return gqlClient.request(setupIntent, { input });
}
